import { TechRefStoreDispatch } from '@squareup/dex-tech-shell';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useDispatch } from 'react-redux';

type DispatchFunc = () => TechRefStoreDispatch;
export const useTechRefDispatch: DispatchFunc = useDispatch;
